// extracted by mini-css-extract-plugin
export default {"container":"Select_container__OKYk-","horizontal-label":"Select_horizontal-label__vrLmo","disabled":"Select_disabled__XKqCR","select":"Select_select__mvF5R"};